import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 3l0 18","key":"svg-1"}],["path",{"d":"M12 12l6.3 6.3","key":"svg-2"}],["path",{"d":"M12 12l-6.3 6.3","key":"svg-3"}]]

const IconPeace = createReactComponent('outline', 'peace', 'Peace', __iconNode);

export default IconPeace;